export type YesOrNo = 'YES' | 'NO';

export const YES: YesOrNo = 'YES';

export const NO: YesOrNo = 'NO';
